import React, { useEffect, useState } from 'react'
import { TabView, TabPanel } from 'primereact/tabview'
import { MdPrint } from 'react-icons/md'
import { useTranslation } from 'react-i18next'

import ReusableModal from '../../../shared/ReuseableModal'
import CustomButton from '../../../shared/CustomButton'
import NoDataFound from '../../../shared/NoDataFound'
import { handlePrintData } from '../../../utils/PrintData'

const PayBillInvoicesModal = ({ isVisible, onClose, invoices = [] }) => {
  const { t } = useTranslation()
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (isVisible) setActiveIndex(0)
  }, [isVisible, invoices])

  const activeInvoice = invoices?.[activeIndex]

  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      title={t('Invoices')}
      position='top'
      className='w-full md:w-[800px] lg:w-[900px]'
      headerClassName='!border-b !border-b-gray-200'
      footerButtons={
        invoices?.length ? (
          <div className='flex justify-end'>
            <CustomButton
              buttonType='primary'
              icon={<MdPrint size={16} className='me-1' />}
              label={t('PrintInvoice')}
              onClick={() => handlePrintData(activeInvoice?.html, 'Invoice')}
            />
          </div>
        ) : null
      }
    >
      {invoices?.length ? (
        <TabView
          activeIndex={activeIndex}
          onTabChange={e => setActiveIndex(e.index)}
          pt={{
            nav: { className: 'w-full border-b border-b-gray-300' },
            panelcontainer: { className: 'bg-transparent !p-0' }
          }}
        >
          {invoices.map((invoice, index) => (
            <TabPanel
              key={invoice?.invoiceNumber || index}
              header={`${t('Invoice')} ${invoice?.invoiceNumber}`}
            >
              <div
                className='scrollbar max-h-[60vh] overflow-y-auto border border-gray-200 rounded-md bg-white p-3'
                dangerouslySetInnerHTML={{ __html: invoice?.html || '' }}
              />
            </TabPanel>
          ))}
        </TabView>
      ) : (
        <div className='flex items-center justify-center flex-col w-full py-6'>
          <NoDataFound
            title={t('No Invoice Data Found.')}
            titleClassName={'text-20-gray'}
            iconSize='40'
          />
        </div>
      )}
    </ReusableModal>
  )
}

export default PayBillInvoicesModal
